import type { Die } from '../die.type';
import { Modifier } from '../modifier';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';
import type { Player } from '../player.type';
import type { Technique } from '../techniques.type';

export class TwinSpell extends Modifier {
  static readonly baseTitle = 'TwinSpell';
  static readonly baseText = 'Repeats next technique used, then fade.';
  static readonly baseIcon = 'twincast';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = TwinSpell.baseTitle;
  text = TwinSpell.baseText;
  icon = TwinSpell.baseIcon;
  tags: Array<ModifierTags> = [...TwinSpell.baseTags];
  priority = TwinSpell.basePriority;

  useTechnique(technique: Technique, target: Player, source: Player, die: Array<Die>) {
    technique.activate(target, source, die);

    this.removeStacks(1);
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.TwinSpell, TwinSpell);
